import type { FolderItem } from "@/types/fse";

export interface PathSegment {
  id: string;
  name: string;
}

export const getDedupedPath = (path: PathSegment[]): PathSegment[] => {
  const seen = new Set<string>();

  return path.filter(segment => {
    if (seen.has(segment.id)) return false;
    seen.add(segment.id);
    return true;
  });
};

export const getPathAfterFolderClick = (path: PathSegment[], folderId: string, folderName: string): PathSegment[] => {
  const existingIndex = path.findIndex(segment => segment.id === folderId);

  if (existingIndex === path.length - 1) {
    return path;
  }

  if (existingIndex !== -1) {
    return path.slice(0, existingIndex + 1);
  }

  return getDedupedPath([...path, { id: folderId, name: folderName }]);
};

export const getPathForFolder = (folder: FolderItem): PathSegment[] => {
  if (folder.parent_fs_id === null) return [];

  const ancestorPath = folder.current_location.path.slice(1);

  return getDedupedPath([...ancestorPath, { id: folder.id, name: folder.name }]);
};
